export default {
    Advance: 0, // Tạm ứng
    Payment: 1, // Thanh toán
  };
  